import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <path d="M8 2v4"/>
  <path d="M16 2v4"/>
  <path d="M3 10h18"/>
  <rect width="18" height="18" x="3" y="4" rx="2"/>
</svg>`;

const Calendar = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='calendar' svg={svg} {...props} />
  )
);

Calendar.displayName = 'CalendarIcon';

export default Calendar;
